import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import translations from "./translations"

i18n.use(initReactI18next).init({
  lng: ["fr", "en"],
  resources: translations,
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
